export default {
  administrators: 'ADMINISTRATORS',
  administrator: 'ADMINISTRATOR',
  createAdministrator: 'CREATE_ADMINISTRATOR',
  updateAdministrator: 'UPDATE_ADMINISTRATOR',
  updateAdministratorStatus: 'UPDATE_ADMINISTRATOR_STATUS',
  deleteAdministrator: 'DELETE_ADMINISTRATOR',
};
